// SPDX-License-Identifier: AGPL-3.0-or-later
// Copyright (C) 2025 Collab Digital Twins

import React from 'react'

export interface IfcIconProps {
  className?: string
  size?: number | string
  monochromatic?: boolean
}

// IFC logo icon
export const IfcIcon = React.memo(function IfcIcon({ className = 'h-4 w-4', size, monochromatic = true }: IfcIconProps) {
  return (
    <svg
      id="ifc-logo"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 199.04 199.19"
      className={className}
      width={size}
      height={size}
    >
      <path fill={monochromatic ? "currentColor" : "#004f9f"} d="m44.73,122.66c7.34,7.8,19.6,8.17,27.4.83l25.53-24.03-16.28-17.3-39.64,37.31,3,3.18Z" />
      <path fill={monochromatic ? "currentColor" : "#004f9f"} d="m5.27,80.74l16.34,17.36,17.3-16.28-13.34-14.18,43.6-41.04,49.75,52.85,3.3-3.11c7.79-7.34,8.16-19.6.83-27.4L83.59,7.02c-7.34-7.8-19.6-8.17-27.4-.83L6.1,53.34c-7.8,7.34-8.17,19.6-.83,27.4Z" />
      <path fill={monochromatic ? "currentColor" : "#9f358b"} d="m122.66,154.31c7.79-7.34,8.17-19.6.83-27.4l-24.03-25.53-17.3,16.28,37.31,39.64,3.18-3Z" />
      <path fill={monochromatic ? "currentColor" : "#9f358b"} d="m80.74,193.77l17.36-16.34-16.28-17.3-14.18,13.34-41.04-43.6,52.85-49.75-3.11-3.3c-7.34-7.8-19.6-8.17-27.4-.83L7.02,115.45c-7.8,7.34-8.17,19.6-.83,27.4l47.15,50.09c7.34,7.79,19.6,8.17,27.4.83Z" />
      <path fill={monochromatic ? "currentColor" : "#009eb0"} d="m154.31,76.38c-7.34-7.8-19.6-8.17-27.4-.83l-25.53,24.03,16.28,17.3,39.64-37.31-3-3.18Z" />
      <path fill={monochromatic ? "currentColor" : "#009eb0"} d="m193.77,118.3l-16.34-17.36-17.3,16.28,13.34,14.17-43.61,41.04-49.75-52.85-3.3,3.11c-7.79,7.34-8.17,19.6-.83,27.4l39.46,41.92c7.34,7.8,19.6,8.17,27.4.83l50.09-47.15c7.8-7.34,8.17-19.6.83-27.4" />
      <path fill={monochromatic ? "currentColor" : "#f00023"} d="m76.38,44.73c-7.8,7.34-8.17,19.6-.83,27.4l24.03,25.52,17.3-16.28-37.31-39.64-3.18,3Z" />
      <path fill={monochromatic ? "currentColor" : "#f00023"} d="m118.3,5.27l-17.36,16.34,16.28,17.3,14.17-13.34,41.04,43.6-52.85,49.75,3.11,3.3c7.34,7.79,19.6,8.17,27.4.83l41.92-39.46c7.79-7.34,8.17-19.6.83-27.4L145.7,6.1c-7.33-7.8-19.6-8.17-27.4-.83" />
      <path fill={monochromatic ? "currentColor" : "#1c1c1b"} d="m189.7,199.19c-4.81,0-8.73-3.99-8.73-8.9s3.92-8.9,8.73-8.9,8.78,3.99,8.78,8.9-3.94,8.9-8.78,8.9Zm0-16.52c-1.99,0-3.85.8-5.22,2.26-1.35,1.43-2.09,3.34-2.09,5.35s.74,3.92,2.09,5.35c1.37,1.46,3.22,2.26,5.22,2.26,4.05,0,7.35-3.42,7.35-7.62s-3.3-7.62-7.35-7.62Zm4.67,12.98h-1.74l-2.91-4.79h-2.17v4.79h-1.28v-10.53h4.01c2.26,0,3.36.93,3.36,2.86s-1.22,2.59-2.38,2.83l3.11,4.84Zm-6.82-6.03h1.79c1.71,0,2.92-.12,2.92-1.67,0-1.08-.74-1.6-2.27-1.6h-2.44v3.27Z" />
    </svg>
  )
})
